import { useCallback, useState } from 'react';

/*
  A billing action applies to one contract. With a single candidate it runs straight away;
  with several the coach is asked first, because the answer decides which product is
  affected.
*/
const useContractChoice = () => {
  const [pending, setPending] = useState(null);

  const request = useCallback((candidates, onChosen, title) => {
    if (!candidates.length) {
      return;
    }
    if (candidates.length === 1) {
      onChosen(candidates[0]);
      return;
    }
    setPending({ candidates, onChosen, title });
  }, []);

  const confirm = useCallback((contractId) => {
    const chosen = pending?.candidates.find((candidate) => candidate.contractId === contractId);
    setPending(null);
    if (chosen) {
      pending.onChosen(chosen);
    }
  }, [pending]);

  const dismiss = useCallback(() => setPending(null), []);

  return {
    pendingCandidates: pending?.candidates || null,
    pendingTitle: pending?.title || '',
    request,
    confirm,
    dismiss,
  };
};

export default useContractChoice;
